import _slicedToArray from "/vercel/path0/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path0/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/vercel/path0/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
var _excluded = ["theme", "type"],
  _excluded2 = ["delay", "staleId"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import t, { isValidElement as e, useRef as n, useLayoutEffect as o, useEffect as s, cloneElement as a, useReducer as r, useState as i, forwardRef as l } from "react";
import c from "clsx";
var u = function u(t) {
    return "number" == typeof t && !isNaN(t);
  },
  d = function d(t) {
    return "string" == typeof t;
  },
  p = function p(t) {
    return "function" == typeof t;
  },
  m = function m(t) {
    return d(t) || p(t) ? t : null;
  },
  f = function f(t) {
    return e(t) || d(t) || p(t) || u(t);
  };
function g(t, e, n) {
  void 0 === n && (n = 300);
  var o = t.scrollHeight,
    s = t.style;
  requestAnimationFrame(function () {
    s.minHeight = "initial", s.height = o + "px", s.transition = "all ".concat(n, "ms"), requestAnimationFrame(function () {
      s.height = "0", s.padding = "0", s.margin = "0", setTimeout(e, n);
    });
  });
}
function h(e) {
  var a = e.enter,
    r = e.exit,
    _e$appendPosition = e.appendPosition,
    i = _e$appendPosition === void 0 ? !1 : _e$appendPosition,
    _e$collapse = e.collapse,
    l = _e$collapse === void 0 ? !0 : _e$collapse,
    _e$collapseDuration = e.collapseDuration,
    c = _e$collapseDuration === void 0 ? 300 : _e$collapseDuration;
  return function (e) {
    var u = e.children,
      d = e.position,
      p = e.preventExitTransition,
      m = e.done,
      f = e.nodeRef,
      h = e.isIn;
    var y = i ? "".concat(a, "--").concat(d) : a,
      v = i ? "".concat(r, "--").concat(d) : r,
      T = n(0);
    return o(function () {
      var _t$classList2;
      var t = f.current,
        e = y.split(" "),
        n = function n(o) {
          var _t$classList;
          o.target === f.current && (t.dispatchEvent(new Event("d")), t.removeEventListener("animationend", n), t.removeEventListener("animationcancel", n), 0 === T.current && "animationcancel" !== o.type && (_t$classList = t.classList).remove.apply(_t$classList, _toConsumableArray(e)));
        };
      (_t$classList2 = t.classList).add.apply(_t$classList2, _toConsumableArray(e)), t.addEventListener("animationend", n), t.addEventListener("animationcancel", n);
    }, []), s(function () {
      var t = f.current,
        e = function e() {
          t.removeEventListener("animationend", e), l ? g(t, m, c) : m();
        };
      h || (p ? e() : (T.current = 1, t.className += " ".concat(v), t.addEventListener("animationend", e)));
    }, [h]), t.createElement(t.Fragment, null, u);
  };
}
function y(t, e) {
  return {
    content: t.content,
    containerId: t.props.containerId,
    id: t.props.toastId,
    theme: t.props.theme,
    type: t.props.type,
    data: t.props.data || {},
    isLoading: t.props.isLoading,
    icon: t.props.icon,
    status: e
  };
}
var v = {
    list: new Map(),
    emitQueue: new Map(),
    on: function on(t, e) {
      return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
    },
    off: function off(t, e) {
      if (e) {
        var _n = this.list.get(t).filter(function (t) {
          return t !== e;
        });
        return this.list.set(t, _n), this;
      }
      return this.list.delete(t), this;
    },
    cancelEmit: function cancelEmit(t) {
      var e = this.emitQueue.get(t);
      return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
    },
    emit: function emit(t) {
      var _arguments = arguments,
        _this = this;
      this.list.has(t) && this.list.get(t).forEach(function (e) {
        var n = setTimeout(function () {
          e.apply(void 0, _toConsumableArray([].slice.call(_arguments, 1)));
        }, 0);
        _this.emitQueue.has(t) || _this.emitQueue.set(t, []), _this.emitQueue.get(t).push(n);
      });
    }
  },
  T = function T(e) {
    var n = e.theme,
      o = e.type,
      s = _objectWithoutProperties(e, _excluded);
    return t.createElement("svg", _objectSpread({
      viewBox: "0 0 24 24",
      width: "100%",
      height: "100%",
      fill: "colored" === n ? "currentColor" : "var(--toastify-icon-color-".concat(o, ")")
    }, s));
  },
  E = {
    info: function info(e) {
      return t.createElement(T, _objectSpread({}, e), t.createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
      }));
    },
    warning: function warning(e) {
      return t.createElement(T, _objectSpread({}, e), t.createElement("path", {
        d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
      }));
    },
    success: function success(e) {
      return t.createElement(T, _objectSpread({}, e), t.createElement("path", {
        d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
      }));
    },
    error: function error(e) {
      return t.createElement(T, _objectSpread({}, e), t.createElement("path", {
        d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
      }));
    },
    spinner: function spinner() {
      return t.createElement("div", {
        className: "Toastify__spinner"
      });
    }
  };
function C(t) {
  var _r = r(function (t) {
      return t + 1;
    }, 0),
    _r2 = _slicedToArray(_r, 2),
    o = _r2[1],
    _i = i([]),
    _i2 = _slicedToArray(_i, 2),
    l = _i2[0],
    c = _i2[1],
    g = n(null),
    h = n(new Map()).current,
    T = function T(t) {
      return -1 !== l.indexOf(t);
    },
    C = n({
      toastKey: 1,
      displayedToast: 0,
      count: 0,
      queue: [],
      props: t,
      containerId: null,
      isToastActive: T,
      getToast: function getToast(t) {
        return h.get(t);
      }
    }).current;
  function I(t) {
    var e = t.containerId;
    var n = C.props.limit;
    !n || e && C.containerId !== e || (C.count -= C.queue.length, C.queue = []);
  }
  function b(t) {
    c(function (e) {
      return null == t ? [] : e.filter(function (e) {
        return e !== t;
      });
    });
  }
  function _() {
    var _C$queue$shift = C.queue.shift(),
      t = _C$queue$shift.toastContent,
      e = _C$queue$shift.toastProps,
      n = _C$queue$shift.staleId;
    O(t, e, n);
  }
  function L(t, n) {
    var s = n.delay,
      r = n.staleId,
      i = _objectWithoutProperties(n, _excluded2);
    if (!f(t) || function (t) {
      return !g.current || C.props.enableMultiContainer && t.containerId !== C.props.containerId || h.has(t.toastId) && null == t.updateId;
    }(i)) return;
    var l = i.toastId,
      c = i.updateId,
      T = i.data,
      I = C.props,
      L = function L() {
        return b(l);
      },
      N = null == c;
    N && C.count++;
    var M = _objectSpread(_objectSpread(_objectSpread({}, I), {}, {
      style: I.toastStyle,
      key: C.toastKey++
    }, i), {}, {
      toastId: l,
      updateId: c,
      data: T,
      closeToast: L,
      isIn: !1,
      className: m(i.className || I.toastClassName),
      bodyClassName: m(i.bodyClassName || I.bodyClassName),
      progressClassName: m(i.progressClassName || I.progressClassName),
      autoClose: !i.isLoading && (R = i.autoClose, w = I.autoClose, !1 === R || u(R) && R > 0 ? R : w),
      deleteToast: function deleteToast() {
        var t = y(h.get(l), "removed");
        h.delete(l), v.emit(4, t);
        var e = C.queue.length;
        if (C.count = null == l ? C.count - C.displayedToast : C.count - 1, C.count < 0 && (C.count = 0), e > 0) {
          var _t = null == l ? C.props.limit : 1;
          if (1 === e || 1 === _t) C.displayedToast++, _();else {
            var _n2 = _t > e ? e : _t;
            C.displayedToast = _n2;
            for (var _t2 = 0; _t2 < _n2; _t2++) {
              _();
            }
          }
        } else o();
      }
    });
    var R, w;
    M.iconOut = function (t) {
      var n = t.theme,
        o = t.type,
        s = t.isLoading,
        r = t.icon,
        i = null;
      var l = {
        theme: n,
        type: o
      };
      return !1 === r || (p(r) ? i = r(l) : e(r) ? i = a(r, l) : d(r) || u(r) ? i = r : s ? i = E.spinner() : function (t) {
        return t in E;
      }(o) && (i = E[o](l))), i;
    }(M), p(i.onOpen) && (M.onOpen = i.onOpen), p(i.onClose) && (M.onClose = i.onClose), M.closeButton = I.closeButton, !1 === i.closeButton || f(i.closeButton) ? M.closeButton = i.closeButton : !0 === i.closeButton && (M.closeButton = !f(I.closeButton) || I.closeButton);
    var x = t;
    e(t) && !d(t.type) ? x = a(t, {
      closeToast: L,
      toastProps: M,
      data: T
    }) : p(t) && (x = t({
      closeToast: L,
      toastProps: M,
      data: T
    })), I.limit && I.limit > 0 && C.count > I.limit && N ? C.queue.push({
      toastContent: x,
      toastProps: M,
      staleId: r
    }) : u(s) ? setTimeout(function () {
      O(x, M, r);
    }, s) : O(x, M, r);
  }
  function O(t, e, n) {
    var o = e.toastId;
    n && h.delete(n);
    var s = {
      content: t,
      props: e
    };
    h.set(o, s), c(function (t) {
      return [].concat(_toConsumableArray(t), [o]).filter(function (t) {
        return t !== n;
      });
    }), v.emit(4, y(s, null == s.props.updateId ? "added" : "updated"));
  }
  return s(function () {
    return C.containerId = t.containerId, v.cancelEmit(3).on(0, L).on(1, function (t) {
      return g.current && b(t);
    }).on(5, I).emit(2, C), function () {
      h.clear(), v.emit(3, C);
    };
  }, []), s(function () {
    C.props = t, C.isToastActive = T, C.displayedToast = l.length;
  }), {
    getToastToRender: function getToastToRender(e) {
      var n = new Map(),
        o = Array.from(h.values());
      return t.newestOnTop && o.reverse(), o.forEach(function (t) {
        var e = t.props.position;
        n.has(e) || n.set(e, []), n.get(e).push(t);
      }), Array.from(n, function (t) {
        return e(t[0], t[1]);
      });
    },
    containerRef: g,
    isToastActive: T
  };
}
function I(t) {
  return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function b(t) {
  return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function _(t) {
  var _i3 = i(!1),
    _i4 = _slicedToArray(_i3, 2),
    o = _i4[0],
    a = _i4[1],
    _i5 = i(!1),
    _i6 = _slicedToArray(_i5, 2),
    r = _i6[0],
    l = _i6[1],
    c = n(null),
    u = n({
      start: 0,
      x: 0,
      y: 0,
      delta: 0,
      removalDistance: 0,
      canCloseOnClick: !0,
      canDrag: !1,
      boundingRect: null,
      didMove: !1
    }).current,
    d = n(t),
    m = t.autoClose,
    f = t.pauseOnHover,
    g = t.closeToast,
    h = t.onClick,
    y = t.closeOnClick;
  function v(e) {
    if (t.draggable) {
      "touchstart" === e.nativeEvent.type && e.nativeEvent.preventDefault(), u.didMove = !1, document.addEventListener("mousemove", _), document.addEventListener("mouseup", L), document.addEventListener("touchmove", _), document.addEventListener("touchend", L);
      var _n3 = c.current;
      u.canCloseOnClick = !0, u.canDrag = !0, u.boundingRect = _n3.getBoundingClientRect(), _n3.style.transition = "", u.x = I(e.nativeEvent), u.y = b(e.nativeEvent), "x" === t.draggableDirection ? (u.start = u.x, u.removalDistance = _n3.offsetWidth * (t.draggablePercent / 100)) : (u.start = u.y, u.removalDistance = _n3.offsetHeight * (80 === t.draggablePercent ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
    }
  }
  function T(e) {
    if (u.boundingRect) {
      var _u$boundingRect = u.boundingRect,
        _n4 = _u$boundingRect.top,
        _o = _u$boundingRect.bottom,
        _s = _u$boundingRect.left,
        _a = _u$boundingRect.right;
      "touchend" !== e.nativeEvent.type && t.pauseOnHover && u.x >= _s && u.x <= _a && u.y >= _n4 && u.y <= _o ? C() : E();
    }
  }
  function E() {
    a(!0);
  }
  function C() {
    a(!1);
  }
  function _(e) {
    var n = c.current;
    u.canDrag && n && (u.didMove = !0, o && C(), u.x = I(e), u.y = b(e), u.delta = "x" === t.draggableDirection ? u.x - u.start : u.y - u.start, u.start !== u.x && (u.canCloseOnClick = !1), n.style.transform = "translate".concat(t.draggableDirection, "(").concat(u.delta, "px)"), n.style.opacity = "" + (1 - Math.abs(u.delta / u.removalDistance)));
  }
  function L() {
    document.removeEventListener("mousemove", _), document.removeEventListener("mouseup", L), document.removeEventListener("touchmove", _), document.removeEventListener("touchend", L);
    var e = c.current;
    if (u.canDrag && u.didMove && e) {
      if (u.canDrag = !1, Math.abs(u.delta) > u.removalDistance) return l(!0), void t.closeToast();
      e.style.transition = "transform 0.2s, opacity 0.2s", e.style.transform = "translate".concat(t.draggableDirection, "(0)"), e.style.opacity = "1";
    }
  }
  s(function () {
    d.current = t;
  }), s(function () {
    return c.current && c.current.addEventListener("d", E, {
      once: !0
    }), p(t.onOpen) && t.onOpen(e(t.children) && t.children.props), function () {
      var t = d.current;
      p(t.onClose) && t.onClose(e(t.children) && t.children.props);
    };
  }, []), s(function () {
    return t.pauseOnFocusLoss && (document.hasFocus() || C(), window.addEventListener("focus", E), window.addEventListener("blur", C)), function () {
      t.pauseOnFocusLoss && (window.removeEventListener("focus", E), window.removeEventListener("blur", C));
    };
  }, [t.pauseOnFocusLoss]);
  var O = {
    onMouseDown: v,
    onTouchStart: v,
    onMouseUp: T,
    onTouchEnd: T
  };
  return m && f && (O.onMouseEnter = C, O.onMouseLeave = E), y && (O.onClick = function (t) {
    h && h(t), u.canCloseOnClick && g();
  }), {
    playToast: E,
    pauseToast: C,
    isRunning: o,
    preventExitTransition: r,
    toastRef: c,
    eventHandlers: O
  };
}
function L(e) {
  var n = e.closeToast,
    o = e.theme,
    _e$ariaLabel = e.ariaLabel,
    s = _e$ariaLabel === void 0 ? "close" : _e$ariaLabel;
  return t.createElement("button", {
    className: "Toastify__close-button Toastify__close-button--".concat(o),
    type: "button",
    onClick: function onClick(t) {
      t.stopPropagation(), n(t);
    },
    "aria-label": s
  }, t.createElement("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, t.createElement("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}
function O(e) {
  var n = e.delay,
    o = e.isRunning,
    s = e.closeToast,
    _e$type = e.type,
    a = _e$type === void 0 ? "default" : _e$type,
    r = e.hide,
    i = e.className,
    l = e.style,
    u = e.controlledProgress,
    d = e.progress,
    m = e.rtl,
    f = e.isIn,
    g = e.theme;
  var h = r || u && 0 === d,
    y = _objectSpread(_objectSpread({}, l), {}, {
      animationDuration: "".concat(n, "ms"),
      animationPlayState: o ? "running" : "paused",
      opacity: h ? 0 : 1
    });
  u && (y.transform = "scaleX(".concat(d, ")"));
  var v = c("Toastify__progress-bar", u ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", "Toastify__progress-bar-theme--".concat(g), "Toastify__progress-bar--".concat(a), {
      "Toastify__progress-bar--rtl": m
    }),
    T = p(i) ? i({
      rtl: m,
      type: a,
      defaultClassName: v
    }) : c(v, i);
  return t.createElement("div", _defineProperty({
    role: "progressbar",
    "aria-hidden": h ? "true" : "false",
    "aria-label": "notification timer",
    className: T,
    style: y
  }, u && d >= 1 ? "onTransitionEnd" : "onAnimationEnd", u && d < 1 ? null : function () {
    f && s();
  }));
}
var N = function N(n) {
    var _ref = _(n),
      o = _ref.isRunning,
      s = _ref.preventExitTransition,
      r = _ref.toastRef,
      i = _ref.eventHandlers,
      l = n.closeButton,
      u = n.children,
      d = n.autoClose,
      m = n.onClick,
      f = n.type,
      g = n.hideProgressBar,
      h = n.closeToast,
      y = n.transition,
      v = n.position,
      T = n.className,
      E = n.style,
      C = n.bodyClassName,
      I = n.bodyStyle,
      b = n.progressClassName,
      N = n.progressStyle,
      M = n.updateId,
      R = n.role,
      w = n.progress,
      x = n.rtl,
      $ = n.toastId,
      k = n.deleteToast,
      P = n.isIn,
      B = n.isLoading,
      D = n.iconOut,
      A = n.closeOnClick,
      z = n.theme,
      F = c("Toastify__toast", "Toastify__toast-theme--".concat(z), "Toastify__toast--".concat(f), {
        "Toastify__toast--rtl": x
      }, {
        "Toastify__toast--close-on-click": A
      }),
      H = p(T) ? T({
        rtl: x,
        position: v,
        type: f,
        defaultClassName: F
      }) : c(F, T),
      S = !!w || !d,
      q = {
        closeToast: h,
        type: f,
        theme: z
      };
    var Q = null;
    return !1 === l || (Q = p(l) ? l(q) : e(l) ? a(l, q) : L(q)), t.createElement(y, {
      isIn: P,
      done: k,
      position: v,
      preventExitTransition: s,
      nodeRef: r
    }, t.createElement("div", _objectSpread(_objectSpread({
      id: $,
      onClick: m,
      className: H
    }, i), {}, {
      style: E,
      ref: r
    }), t.createElement("div", _objectSpread(_objectSpread({}, P && {
      role: R
    }), {}, {
      className: p(C) ? C({
        type: f
      }) : c("Toastify__toast-body", C),
      style: I
    }), null != D && t.createElement("div", {
      className: c("Toastify__toast-icon", {
        "Toastify--animate-icon Toastify__zoom-enter": !B
      })
    }, D), t.createElement("div", null, u)), Q, t.createElement(O, _objectSpread(_objectSpread({}, M && !S ? {
      key: "pb-".concat(M)
    } : {}), {}, {
      rtl: x,
      theme: z,
      delay: d,
      isRunning: o,
      isIn: P,
      closeToast: h,
      hide: g,
      type: f,
      style: N,
      className: b,
      controlledProgress: S,
      progress: w || 0
    }))));
  },
  M = function M(t, e) {
    return void 0 === e && (e = !1), {
      enter: "Toastify--animate Toastify__".concat(t, "-enter"),
      exit: "Toastify--animate Toastify__".concat(t, "-exit"),
      appendPosition: e
    };
  },
  R = h(M("bounce", !0)),
  w = h(M("slide", !0)),
  x = h(M("zoom")),
  $ = h(M("flip")),
  k = l(function (e, n) {
    var _C = C(e),
      o = _C.getToastToRender,
      a = _C.containerRef,
      r = _C.isToastActive,
      i = e.className,
      l = e.style,
      u = e.rtl,
      d = e.containerId;
    function f(t) {
      var e = c("Toastify__toast-container", "Toastify__toast-container--".concat(t), {
        "Toastify__toast-container--rtl": u
      });
      return p(i) ? i({
        position: t,
        rtl: u,
        defaultClassName: e
      }) : c(e, m(i));
    }
    return s(function () {
      n && (n.current = a.current);
    }, []), t.createElement("div", {
      ref: a,
      className: "Toastify",
      id: d
    }, o(function (e, n) {
      var o = n.length ? _objectSpread({}, l) : _objectSpread(_objectSpread({}, l), {}, {
        pointerEvents: "none"
      });
      return t.createElement("div", {
        className: f(e),
        style: o,
        key: "container-".concat(e)
      }, n.map(function (e, o) {
        var s = e.content,
          a = e.props;
        return t.createElement(N, _objectSpread(_objectSpread({}, a), {}, {
          isIn: r(a.toastId),
          style: _objectSpread(_objectSpread({}, a.style), {}, {
            "--nth": o + 1,
            "--len": n.length
          }),
          key: "toast-".concat(a.key)
        }), s);
      }));
    }));
  });
k.displayName = "ToastContainer", k.defaultProps = {
  position: "top-right",
  transition: R,
  autoClose: 5e3,
  closeButton: L,
  pauseOnHover: !0,
  pauseOnFocusLoss: !0,
  closeOnClick: !0,
  draggable: !0,
  draggablePercent: 80,
  draggableDirection: "x",
  role: "alert",
  theme: "light"
};
var P,
  B = new Map(),
  D = [],
  A = 1;
function z() {
  return "" + A++;
}
function F(t) {
  return t && (d(t.toastId) || u(t.toastId)) ? t.toastId : z();
}
function H(t, e) {
  return B.size > 0 ? v.emit(0, t, e) : D.push({
    content: t,
    options: e
  }), e.toastId;
}
function S(t, e) {
  return _objectSpread(_objectSpread({}, e), {}, {
    type: e && e.type || t,
    toastId: F(e)
  });
}
function q(t) {
  return function (e, n) {
    return H(e, S(t, n));
  };
}
function Q(t, e) {
  return H(t, S("default", e));
}
Q.loading = function (t, e) {
  return H(t, S("default", _objectSpread({
    isLoading: !0,
    autoClose: !1,
    closeOnClick: !1,
    closeButton: !1,
    draggable: !1
  }, e)));
}, Q.promise = function (t, e, n) {
  var o,
    s = e.pending,
    a = e.error,
    r = e.success;
  s && (o = d(s) ? Q.loading(s, n) : Q.loading(s.render, _objectSpread(_objectSpread({}, n), s)));
  var i = {
      isLoading: null,
      autoClose: null,
      closeOnClick: null,
      closeButton: null,
      draggable: null,
      delay: 100
    },
    l = function l(t, e, s) {
      if (null == e) return void Q.dismiss(o);
      var a = _objectSpread(_objectSpread(_objectSpread({
          type: t
        }, i), n), {}, {
          data: s
        }),
        r = d(e) ? {
          render: e
        } : e;
      return o ? Q.update(o, _objectSpread(_objectSpread({}, a), r)) : Q(r.render, _objectSpread(_objectSpread({}, a), r)), s;
    },
    c = p(t) ? t() : t;
  return c.then(function (t) {
    return l("success", r, t);
  }).catch(function (t) {
    return l("error", a, t);
  }), c;
}, Q.success = q("success"), Q.info = q("info"), Q.error = q("error"), Q.warning = q("warning"), Q.warn = Q.warning, Q.dark = function (t, e) {
  return H(t, S("default", _objectSpread({
    theme: "dark"
  }, e)));
}, Q.dismiss = function (t) {
  B.size > 0 ? v.emit(1, t) : D = D.filter(function (e) {
    return null != t && e.options.toastId !== t;
  });
}, Q.clearWaitingQueue = function (t) {
  return void 0 === t && (t = {}), v.emit(5, t);
}, Q.isActive = function (t) {
  var e = !1;
  return B.forEach(function (n) {
    n.isToastActive && n.isToastActive(t) && (e = !0);
  }), e;
}, Q.update = function (t, e) {
  void 0 === e && (e = {}), setTimeout(function () {
    var n = function (t, e) {
      var n = e.containerId;
      var o = B.get(n || P);
      return o && o.getToast(t);
    }(t, e);
    if (n) {
      var _o2 = n.props,
        _s2 = n.content,
        _a2 = _objectSpread(_objectSpread(_objectSpread({}, _o2), e), {}, {
          toastId: e.toastId || t,
          updateId: z()
        });
      _a2.toastId !== t && (_a2.staleId = t);
      var _r3 = _a2.render || _s2;
      delete _a2.render, H(_r3, _a2);
    }
  }, 0);
}, Q.done = function (t) {
  Q.update(t, {
    progress: 1
  });
}, Q.onChange = function (t) {
  return v.on(4, t), function () {
    v.off(4, t);
  };
}, Q.POSITION = {
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  TOP_CENTER: "top-center",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_CENTER: "bottom-center"
}, Q.TYPE = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  DEFAULT: "default"
}, v.on(2, function (t) {
  P = t.containerId || t, B.set(P, t), D.forEach(function (t) {
    v.emit(0, t.content, t.options);
  }), D = [];
}).on(3, function (t) {
  B.delete(t.containerId || t), 0 === B.size && v.off(0).off(1).off(5);
});
export { R as Bounce, $ as Flip, E as Icons, w as Slide, k as ToastContainer, x as Zoom, g as collapseToast, h as cssTransition, Q as toast, _ as useToast, C as useToastContainer };